module.exports = __webpack_public_path__ + "img/part5-3.a898b4b7.png";